module.exports = __webpack_public_path__ + "static/media/DECO.d6eb5f90.svg";